/**
 * Password show/hide - the eye button inside .password-field wrappers.
 *
 *   <div class="password-field">
 *     <input type="password" class="form-control" ... />
 *     <button type="button" class="password-toggle" aria-label="Show password"><i class="ri-eye-line"></i></button>
 *   </div>
 *
 * Delegated, so fields rendered later (dialogs, dynamic forms) work too.
 * Styles: assets/scss/components/_password.scss.
 *
 * While a password is shown in CLEAR TEXT, asking to confirm it is
 * redundant - so revealing a field HIDES its confirm field (the input in
 * the same form whose validate-same-as points at this field's name) and
 * keeps the confirm value mirrored, so a backend expecting both still
 * gets a matching pair. Hiding the password again brings the confirm
 * field back (the mirrored value keeps the pair valid until edited).
 */

// The block an input lives in (label + control): the field's own grid
// column or .mb-* group - what our form standard always wraps fields in.
function fieldBlock(input) {
	return input.closest('div[class*="col-"], div[class*="mb-"]') || input.parentElement;
}

function confirmFieldsOf(input) {
	if (!input.name || !input.form) return [];
	const sel = '[validate-same-as="' + CSS.escape(input.name) + '"], [data-validate-same-as="' + CSS.escape(input.name) + '"]';
	return Array.from(input.form.querySelectorAll(sel));
}

function syncConfirms(input) {
	for (const confirm of confirmFieldsOf(input)) confirm.value = input.value;
}

function toggleConfirms(input, shown) {
	for (const confirm of confirmFieldsOf(input)) {
		fieldBlock(confirm).hidden = shown;
		if (shown) {
			confirm.value = input.value;
			// a stale "does not match" under a field that no longer exists visually
			if (window.g && window.g.fieldError) window.g.fieldError(confirm, null);
		}
	}
}

export function initPassword() {
	document.addEventListener('click', (e) => {
		if (!(e.target instanceof Element)) return;
		const btn = e.target.closest('.password-toggle');
		if (!btn) return;
		const input = btn.closest('.password-field') && btn.closest('.password-field').querySelector('input');
		if (!input) return;
		const show = input.type === 'password';
		input.type = show ? 'text' : 'password';
		btn.setAttribute('aria-pressed', String(show));
		btn.setAttribute('aria-label', show ? 'Hide password' : 'Show password');
		const icon = btn.querySelector('i');
		if (icon) icon.className = show ? 'ri-eye-off-line' : 'ri-eye-line';
		toggleConfirms(input, show);
		input.focus({ preventScroll: true });
	});

	// keep the hidden confirm mirrored while the password is visible
	document.addEventListener('input', (e) => {
		const input = e.target;
		if (!(input instanceof HTMLInputElement) || input.type !== 'text') return;
		if (!input.closest('.password-field')) return;
		syncConfirms(input);
	});
}
